function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import gettext from 'js-utils/gettext';
import { uploadImageFile, updateImage, transformToApiCropMask, IMAGE_TYPES } from 'js-utils/http';
import ImageUploader from '../imageUploader/ImageUploader';
import ValidationFormField from '../validationFormField/ValidationFormField';
import { SVG_PROP_TYPE } from '../vectorImage/constants';
import { CROP_MASK_PROP_TYPE } from '../imageCropper/constants';
import { getCroppedImageDataURL } from '../utils/image';
import withOverlayControlsHOC from '../structure/hoc/withOverlayControls';
import { TYPE_COMPLEX } from '../modal/constants';
import { STYLE_FILL, STYLE_NEUTRAL } from '../button/constants';
import NotificationBar from '../notification/NotificationBar';
import { TYPE_ERROR } from '../notification/constants';
import ConstrainedHeightCropper from './_internal/ConstrainedHeightCropper';
import { CROP_DISALLOWED, CROP_REQUIRED, CROP_INTENTIONS, REQUIRED_CROP_CANCELED } from './constants';
import { transformUploadFailureMessage, conditionalDeepCompare, pickPropsByTypes } from './utils';

var ImageUploaderField = function ImageUploaderField(_ref) {
  var value = _ref.value,
      props = _objectWithoutProperties(_ref, ["value"]);

  return React.createElement(ImageUploader, _extends({}, pickPropsByTypes(props, ImageUploader.propTypes), {
    imageUrl: value
  }));
};

var CropperError = function CropperError(_ref2) {
  var error = _ref2.error;

  if (!error) {
    return null;
  }

  return React.createElement("div", {
    className: "eds-l-mar-bot-2",
    "data-spec": "cropper-modal-error"
  }, React.createElement(NotificationBar, {
    type: TYPE_ERROR,
    shouldScrollTo: true
  }, error));
};

var DEFAULT_CROP_STATE = {
  continueUpload: noop,
  cancelUpload: noop,
  setCroppedImage: noop,
  workingCropMask: undefined,
  showCropper: false,
  cropperImageUrl: undefined,
  isEditingCrop: false,
  cropIsSaving: false
};

var ImageField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ImageField, _React$Component);

  function ImageField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ImageField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ImageField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({}, DEFAULT_CROP_STATE, {
      cropError: undefined
    }));

    return _this;
  }

  _createClass(ImageField, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !conditionalDeepCompare(this.props, nextProps, 'cropMask') || !conditionalDeepCompare(this.state, nextState, 'workingCropMask');
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          showOverlay = _this$props.showOverlay,
          imageAlt = _this$props.imageAlt,
          cropAspectRatio = _this$props.cropAspectRatio,
          cropMask = _this$props.cropMask;
      var _this$state = this.state,
          showCropper = _this$state.showCropper,
          cropperImageUrl = _this$state.cropperImageUrl;
      /**
       * We need to set an intention to show the cropper before `cropperImageUrl` is
       * available when uploading a new image.
       * During initial upload:
       *      A synchronous process (user chooses the file) will set `showCropper`.
       *      An async process (loading image URL from local file) will set `cropperImageUrl`.
       * We should only show the modal when both are fulfilled.
       * If crop isn't required, `cropperImageUrl` will be set but no crop is needed.
       * Therefore, we should check both to see if we should show cropper.
       *
       * During edit, both `showCropper` and `cropperImageUrl` will be set at the same time.
       */

      if (showCropper && cropperImageUrl) {
        showOverlay('modal', {
          type: TYPE_COMPLEX,
          title: gettext('Crop Image'),
          onClose: this._handleCropCancel.bind(this),
          onPrimaryAction: this._handleCropSave.bind(this),
          primaryText: gettext('Save'),
          primaryType: STYLE_FILL,
          onSecondaryAction: this._handleCropCancel.bind(this),
          secondaryText: gettext('Cancel'),
          secondaryType: STYLE_NEUTRAL,
          children: React.createElement(ConstrainedHeightCropper, {
            imageSrc: cropperImageUrl,
            onCropDone: this._handleCrop.bind(this),
            imageAltText: imageAlt,
            aspectRatio: cropAspectRatio,
            cropMask: cropMask
          })
        });
      }
    }
  }, {
    key: "_handleCrop",
    value: function _handleCrop(workingCropMask) {
      this.setState({
        workingCropMask: workingCropMask
      });
    }
  }, {
    key: "_interceptProgressImage",
    value: function _interceptProgressImage(cropperImageUrl, setCroppedImage) {
      this.setState({
        setCroppedImage: setCroppedImage,
        cropperImageUrl: cropperImageUrl
      });
    }
  }, {
    key: "_handleProgressImageLoaded",
    value: function _handleProgressImageLoaded(progressImage) {
      return new Promise(this._interceptProgressImage.bind(this, progressImage));
    }
  }, {
    key: "_interceptUploadForCropIntention",
    value: function _interceptUploadForCropIntention(continueUpload, cancelUpload) {
      var cropIntention = this.props.cropIntention;

      if (cropIntention !== CROP_REQUIRED) {
        continueUpload();
        return;
      }

      this.setState({
        continueUpload: continueUpload,
        cancelUpload: cancelUpload.bind(null, REQUIRED_CROP_CANCELED),
        showCropper: true,
        isEditingCrop: false
      });
    }
  }, {
    key: "_performUpload",
    value: function _performUpload(file, onProgress, cropMask) {
      var imageType = this.props.imageType;
      var apiCropMask;

      if (cropMask) {
        apiCropMask = transformToApiCropMask(cropMask);
      }

      return uploadImageFile(file, imageType, onProgress, apiCropMask);
    }
  }, {
    key: "_handleUploadSuccess",
    value: function _handleUploadSuccess(apiImage) {
      var updateFieldsFromObject = this.props.updateFieldsFromObject;
      var localCroppedImage = this.state.localCroppedImage;
      var imageUrl = localCroppedImage || apiImage.url;
      updateFieldsFromObject(_objectSpread({}, apiImage, {
        url: imageUrl
      }));
      return imageUrl;
    }
  }, {
    key: "_handleReceiveFile",
    value: function _handleReceiveFile(file, onProgress) {
      var onReceiveFile = this.props.onReceiveFile;

      if (onReceiveFile) {
        onReceiveFile();
      }

      return new Promise(this._interceptUploadForCropIntention.bind(this)).then(this._performUpload.bind(this, file, onProgress)).then(this._handleUploadSuccess.bind(this)).catch(transformUploadFailureMessage);
    }
  }, {
    key: "_handleRemoveImage",
    value: function _handleRemoveImage() {
      var _this$props2 = this.props,
          updateFieldsFromObject = _this$props2.updateFieldsFromObject,
          onRemoveImage = _this$props2.onRemoveImage;

      if (onRemoveImage) {
        onRemoveImage();
      }

      updateFieldsFromObject();
      this.setState({
        cropError: undefined
      });
    }
  }, {
    key: "_handleCropCancel",
    value: function _handleCropCancel() {
      var cancelUpload = this.state.cancelUpload;
      cancelUpload();

      this._resetCropState();
    }
  }, {
    key: "_handleNewCropSave",
    value: function _handleNewCropSave(cropMask) {
      var _this2 = this;

      var _this$state2 = this.state,
          cropperImageUrl = _this$state2.cropperImageUrl,
          continueUpload = _this$state2.continueUpload,
          setCroppedImage = _this$state2.setCroppedImage;
      getCroppedImageDataURL(cropperImageUrl, cropMask).then(function (dataUri) {
        setCroppedImage(dataUri);

        _this2.setState({
          localCroppedImage: dataUri
        });
      });
      continueUpload(cropMask);

      this._resetCropState();
    }
  }, {
    key: "_resetCropState",
    value: function _resetCropState() {
      this.setState(DEFAULT_CROP_STATE);
    }
  }, {
    key: "_handleEditCrop",
    value: function _handleEditCrop() {
      var _this$props3 = this.props,
          originalUrl = _this$props3.originalUrl,
          onEditImage = _this$props3.onEditImage;

      if (onEditImage) {
        onEditImage();
      }

      this.setState({
        showCropper: true,
        isEditingCrop: true,
        cropperImageUrl: originalUrl,
        cropError: undefined
      });
    }
  }, {
    key: "_handleEditCropSave",
    value: function _handleEditCropSave(cropMask) {
      var imageId = this.props.imageId;
      this.setState({
        cropIsSaving: true,
        showCropper: false
      });
      updateImage(imageId, transformToApiCropMask(cropMask)).then(this._handleEditCropSaveSuccess.bind(this)).catch(this._handleEditCropSaveFailure.bind(this));
    }
  }, {
    key: "_handleEditCropSaveSuccess",
    value: function _handleEditCropSaveSuccess(apiImage) {
      var updateFieldsFromObject = this.props.updateFieldsFromObject;
      updateFieldsFromObject(apiImage);

      this._resetCropState();
    }
  }, {
    key: "_handleEditCropSaveFailure",
    value: function _handleEditCropSaveFailure() {
      this.setState({
        cropError: gettext('Unable to save your crop, please try again'),
        cropIsSaving: false
      });

      this._resetCropState();
    }
  }, {
    key: "_handleCropSave",
    value: function _handleCropSave() {
      var _this$state3 = this.state,
          isEditingCrop = _this$state3.isEditingCrop,
          workingCropMask = _this$state3.workingCropMask;

      if (isEditingCrop) {
        return this._handleEditCropSave(workingCropMask);
      }

      return this._handleNewCropSave(workingCropMask);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          name = _this$props4.name,
          hiddenLabel = _this$props4.hiddenLabel,
          headline = _this$props4.headline,
          description = _this$props4.description,
          iconType = _this$props4.iconType,
          maxFileSize = _this$props4.maxFileSize,
          allowedContentTypes = _this$props4.allowedContentTypes,
          contentTypeError = _this$props4.contentTypeError,
          imageAlt = _this$props4.imageAlt,
          cropIntention = _this$props4.cropIntention,
          bottomSpacing = _this$props4.bottomSpacing,
          onUploadStatusChange = _this$props4.onUploadStatusChange,
          shouldDisplayError = _this$props4.shouldDisplayError;
      var cropError = this.state.cropError;
      var onCrop;

      if (cropIntention !== CROP_DISALLOWED) {
        onCrop = this._handleEditCrop.bind(this);
      }

      return React.createElement("div", null, React.createElement(CropperError, {
        error: cropError
      }), React.createElement(ValidationFormField, {
        name: "".concat(name, "Url"),
        label: hiddenLabel,
        hideLabel: true,
        bottomSpacing: bottomSpacing,
        shouldDisplayError: shouldDisplayError
      }, React.createElement(ImageUploaderField, {
        onReceiveFile: this._handleReceiveFile.bind(this),
        onRemove: this._handleRemoveImage.bind(this),
        onProgressImageLoaded: this._handleProgressImageLoaded.bind(this),
        onCrop: onCrop,
        onUploadStatusChange: onUploadStatusChange,
        headline: headline,
        description: description,
        iconType: iconType,
        maxFileSize: maxFileSize,
        allowedContentTypes: allowedContentTypes,
        contentTypeError: contentTypeError,
        imageAlt: imageAlt
      })));
    }
  }]);

  return ImageField;
}(React.Component);

_defineProperty(ImageField, "propTypes", {
  /**
   * Updates form field values based on new image field data
   * (from calling `connectImageField` in `js-utils/redux`)
   */
  updateFieldsFromObject: PropTypes.func.isRequired,

  /**
   * Name of the image form field
   * (from calling `connectImageField` in `js-utils/redux`)
   */
  name: PropTypes.string.isRequired,

  /**
   * ID of existing image
   * (from calling `connectImageField` in `js-utils/redux`)
   */
  imageId: PropTypes.string,

  /**
   * URL to image (used in cropping)
   * (from calling `connectImageField` in `js-utils/redux`)
   */
  originalUrl: PropTypes.string,

  /**
   * Crop mask to apply
   * (from calling `connectImageField` in `js-utils/redux`)
   */
  cropMask: CROP_MASK_PROP_TYPE,

  /**
   * The API image type
   */
  imageType: PropTypes.oneOf(IMAGE_TYPES).isRequired,

  /**
   * Alt attribute provided to the underlying image tag.
   */
  imageAlt: EBPropTypes.translation.isRequired,

  /**
   * Hidden accessibility label
   */
  hiddenLabel: EBPropTypes.translation.isRequired,

  /**
   * Whether or not cropping is mandatory, optional, or disallowed
   */
  cropIntention: PropTypes.oneOf(CROP_INTENTIONS),

  /**
   * Desired aspect ratio of the resulting crop.
   */
  cropAspectRatio: PropTypes.number,

  /**
   * Primary text shown in the initial uploader state.
   * This should be a call-to-action to the user ("Choose an Image")
   */
  headline: EBPropTypes.translation,

  /**
   * Secondary text shown in the initial uploader state.
   * This can be longer descriptive text to help the user choose an appropriate image.
   */
  description: EBPropTypes.translation,

  /**
   * Icon shown above the headline in the initial uploader state.
   */
  iconType: SVG_PROP_TYPE,

  /**
   * The maximum acceptable filesize specified in megabytes.
   * Files larger than this number will be rejected with an error message.
   */
  maxFileSize: PropTypes.number,

  /**
   * A list of acceptable content-types for dropped files.
   * Files of any type other than those in this list will be rejected with an error message.
   */
  allowedContentTypes: PropTypes.arrayOf(PropTypes.string),

  /**
   * The error message shown to the user if they drop an inappropriate filetype.
   * This can be specified via props to provide a more specific actionable message
   * such as "Please choose a JPG, PNG, or GIF"
   */
  contentTypeError: EBPropTypes.translation,

  /**
   * The amount of spacing for the bottom
   */
  bottomSpacing: PropTypes.number,

  /**
   * Function to determine whether we should
   * display an error given the input state. Has a sensible default.
   */
  shouldDisplayError: PropTypes.func,

  /**
   * Function that's invoked when the user has chosen a file
   */
  onReceiveFile: PropTypes.func,

  /**
   * Function that's invoked when the user clicks "Remove"
   */
  onRemoveImage: PropTypes.func,

  /**
   * Function that's invoked when the user clicks "Crop" button.
   * The "Crop" button is optional will only appear if this
   * function is provided.
   */
  onEditImage: PropTypes.func,

  /**
   * Function that's invoked when the user has chosen a file and returns
   * the status of the ImageUploader process of uploading.
   * Returns 3 possibles strings: 'uploading', 'uploaded', 'failed'.
   */
  onUploadStatusChange: PropTypes.func,
  // From HOCs
  showOverlay: PropTypes.func
});

_defineProperty(ImageField, "defaultProps", {
  cropIntention: CROP_DISALLOWED
});

export default withOverlayControlsHOC(ImageField);